import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import '../../css/Accounts.css';
import MainWrapper from '../wrappers/mainWrapper';
import { useNavigate, useParams } from 'react-router-dom';
import "../../css/App.css";
import Modal from 'react-modal';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

const EditAccount = () => {
    const navigate = useNavigate();
    const params = useParams();
    const getUserId = useSelector(state => state.user);

    const [userData, setUserData] = useState();
    const [responded, setResponded] = useState(false);
    const [active, setActive] = useState({ isActive: false });
    const [submitting, setSubmitting] = useState(false);

    // Pricing Modal State
    const [openPricing, setOpenPricing] = useState(false);
    const [pricingInformation, setPricingInformation] = useState({
        monthly_allotment: 99999,
        additional_cost: 0,
        coupon: ""
    });

    // Post-Registration Modal State
    const [openPostReg, setOpenPostReg] = useState(false);
    const [postReg, setPostReg] = useState({
        roleSelections: [],
        otherRole: "",
        primaryDecisionMaker: null,
        annualRevenue: "",
        goals: [],
        otherGoal: ""
    });

    const roleOptions = ['Independent Restorer', 'Franchised Restorer', 'Independent Adjuster', 'Public Adjuster', 'Captive/Carrier Adjuster', 'Other'];
    const goalOptions = ['Time Savings', 'Increase Accuracy', 'Decision Making Assistance', 'Report Generation', 'Justifications for Line Items', 'Other'];
    const revenueOptions = ['<$500,000', '$500,001-$1M', '$1M-$3M', '$3M+'];

    const modalStyle = { textAlign: 'center', background: 'none', marginBottom: '12px' };
    const modalRestyleLarge = {
        overlay: { top: '25%', left: '25%', width: '50%', height: '70%', position: 'fixed' },
        content: { inset: '5%', border: '1px solid black', backgroundColor: '#f7f7f7', overflow: 'auto', borderRadius: '10px', padding: '20px' }
    };
    const buttonContainer = { display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '20px' };
    const textFieldStyle = { display: 'grid', padding: '4px', backgroundColor: 'white', margin: '12px 0', borderRadius: '4px', width: '95%' };

    const numbersOnly = e => { e.target.value = e.target.value.replace(/\D/g, ''); };
    const numbersAndDec = e => { let value = e.target.value; if (!/^\d*\.?\d{0,2}$/.test(value)) value = value.slice(0, -1); e.target.value = value; };

    useEffect(() => {
        if (!responded) getUser(params.id);
    }, [responded]);

    const getUser = async (id) => {
        const response = await fetch(`${process.env.REACT_APP_GET_USER_DATA}${id}`).then(res => res.json());
        setUserData(response);
        setResponded(true);
        setPostReg({
            roleSelections: response?.userRoleSelections || [],
            otherRole: response?.otherRole || "",
            primaryDecisionMaker: response?.primaryDecisionMaker ?? null,
            annualRevenue: response?.annualRevenue || "",
            goals: response?.goals || [],
            otherGoal: response?.otherGoal || ""
        });
        setPricingInformation({
            monthly_allotment: response?.monthly_allotment || 99999,
            additional_cost: response?.additional_cost || 0,
            coupon: response?.coupon || ""
        });
    };

    const deactivateUser = () => {
        if (userData?.email) {
            fetch(`${process.env.REACT_APP_DEACTIVATE}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: userData.email }) })
                .then(() => getUser(params.id));
        }
    };

    const activateUser = () => {
        if (userData?.email) {
            fetch(`${process.env.REACT_APP_ACTIVATE}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: userData.email }) })
                .then(() => getUser(params.id));
        }
    };

    const handleSavePricing = () => {
        fetch(`${process.env.REACT_APP_SAVE_PRICING}${params.id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(pricingInformation)
        }).then(() => { setOpenPricing(false); getUser(params.id); })
            .catch(err => { console.error(err); alert("Saving pricing failed."); });
    };

    const toggleCheckbox = (list, value, field) => {
        if (list.includes(value)) setPostReg({ ...postReg, [field]: list.filter(v => v !== value) });
        else setPostReg({ ...postReg, [field]: [...list, value] });
    };

    const handleSavePostReg = async () => {
        setSubmitting(true);
        try {
            const token = localStorage.getItem("token");
            const payload = {
                userId: params.id,
                ...postReg
            };

            const res = await fetch(process.env.REACT_APP_SAVE_REG_ROUTE, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    ...(token && { "Authorization": `Bearer ${token}` })
                },
                body: JSON.stringify(payload)
            });

            const data = await res.json();
            if (!data.success) throw new Error(data.message || "Failed to save");

            alert("Registration details saved!");
            setOpenPostReg(false);
            getUser(params.id);
        } catch (err) {
            console.error(err);
            alert("There was an error saving your details.");
        } finally {
            setSubmitting(false);
        }
    };

    const returnVal = val => val ?? "N/A";
    const inlineStatus = { display: 'flex', flexDirection: 'row', alignItems: 'baseline', justifyContent: 'space-between' };
    const returnActive = val => val ? (
        <div style={inlineStatus}>
            <strong>Subscription Status:</strong> <p>Active</p>
            <button className='deactivate-button' onClick={deactivateUser}>Deactivate</button>
        </div>
    ) : (
        <div style={inlineStatus}>
            <strong>Subscription Status:</strong> <p>Inactive</p>
            <button className='activate-button' onClick={activateUser}>Activate</button>
        </div>
    );

    const returnProfileContainer = () => {
        if (!userData) return <div className='profile-container'><h1>Loading...</h1></div>;
        return (
            <div className='profile-container'>
                <div className='account-details' style={{ display: 'flex', gap: '40px' }}>
                    <div style={{ width: '40%' }}>
                        <h2 className='green-large-bold'>ACCOUNT DETAILS</h2>
                        <p className='black-small-bold'>{returnVal(userData?.company?.name)}</p>
                        <p className='black-small'>{returnVal(userData?.email)}</p>

                        <h3 className='green-small-bold' style={{ marginTop: '16px' }}>COMPANY</h3>
                        <p className='black-small-bold'>{returnVal(userData?.company?.name)}</p>
                        <p className='black-small'>{returnVal(userData?.company?.address_1)}</p>
                        <p className='black-small'>{returnVal(userData?.company?.address_2)}</p>
                        <p className='black-small'>{returnVal(userData?.company?.city)} {returnVal(userData?.company?.state)} {returnVal(userData?.company?.zipCode)}</p>

                        <h3 className='green-small-bold' style={{ marginTop: '16px' }}>ACCOUNT TYPE</h3>
                        <p className='black-small-bold'>{userData?.acc_type}</p>

                        <h3 className='green-small-bold' style={{ marginTop: '16px' }}>PHONE NUMBER</h3>
                        <p className='black-small-bold'>{returnVal(userData?.phone)}</p>
                    </div>

                    <div style={{ width: '40%' }}>
                        {returnActive(userData.isActive)}
                        <br />
                        <p><strong>Monthly Allotment: </strong>{userData.monthly_allotment || 0}</p>
                        <p><strong>Additional Cost: </strong>${userData.additional_cost || 9.99}</p>
                        <p><strong>Coupon: </strong>{userData.coupon || ""}</p>
                        <button onClick={() => setOpenPricing(true)} className='pricing-button'>Edit Pricing Model</button>
                        <button onClick={() => setOpenPostReg(true)} className='pricing-button' style={{ marginTop: '8px' }}>Edit Post-Registration Info</button>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className='outer-container'>
            <MainWrapper />
            <div className='right-container' style={{ padding: '24px' }}>
                {returnProfileContainer()}
            </div>

            {/* PRICING MODAL */}
            <Modal ariaHideApp={false} style={modalRestyleLarge} isOpen={openPricing} onRequestClose={() => setOpenPricing(false)}>
                <div style={modalStyle}><h1>Edit Pricing Information</h1></div>
                <TextField style={textFieldStyle} label="Monthly Allotment" onInput={numbersOnly} defaultValue={userData?.monthly_allotment} onBlur={e => setPricingInformation({ ...pricingInformation, monthly_allotment: e.target.value })} />
                <TextField style={textFieldStyle} label="Additional Cost" onInput={numbersAndDec} defaultValue={userData?.additional_cost} onBlur={e => setPricingInformation({ ...pricingInformation, additional_cost: e.target.value })} />
                <TextField style={textFieldStyle} label="Coupon" defaultValue={userData?.coupon} onBlur={e => setPricingInformation({ ...pricingInformation, coupon: e.target.value })} />
                <div style={buttonContainer}>
                    <Button size="small" sx={{ fontWeight: 'bold', color: 'white', backgroundColor: '#723E49' }} onClick={() => setOpenPricing(false)}>Exit</Button>
                    <Button size="small" sx={{ fontWeight: 'bold', color: 'white', backgroundColor: '#00B3B5' }} onClick={handleSavePricing}>Save</Button>
                </div>
            </Modal>

            {/* POST-REGISTRATION MODAL */}
            <Modal ariaHideApp={false} style={modalRestyleLarge} isOpen={openPostReg} onRequestClose={() => setOpenPostReg(false)}>
                <div style={modalStyle}><h1>Edit Post-Registration Info</h1></div>
                <div style={{ padding: '10px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <h3>Roles</h3>
                    {roleOptions.map(role => (
                        <div key={role}>
                            <input type="checkbox" checked={postReg.roleSelections.includes(role)} onChange={() => toggleCheckbox(postReg.roleSelections, role, 'roleSelections')} />
                            <label style={{ marginLeft: '6px' }}>{role}</label>
                            {role === 'Other' && postReg.roleSelections.includes('Other') && (
                                <TextField style={textFieldStyle} label="Other Role" value={postReg.otherRole} onChange={e => setPostReg({ ...postReg, otherRole: e.target.value })} />
                            )}
                        </div>
                    ))}

                    <h3>Primary Decision Maker</h3>
                    <div><input type="radio" name="decision" checked={postReg.primaryDecisionMaker === true} onChange={() => setPostReg({ ...postReg, primaryDecisionMaker: true })} /> Yes</div>
                    <div><input type="radio" name="decision" checked={postReg.primaryDecisionMaker === false} onChange={() => setPostReg({ ...postReg, primaryDecisionMaker: false })} /> No</div>

                    <h3>Annual Revenue</h3>
                    <select value={postReg.annualRevenue} onChange={e => setPostReg({ ...postReg, annualRevenue: e.target.value })} style={{ padding: '8px', borderRadius: '4px' }}>
                        <option value="">Select Revenue Range</option>
                        {revenueOptions.map(r => <option key={r} value={r}>{r}</option>)}
                    </select>

                    <h3>Goals</h3>
                    {goalOptions.map(goal => (
                        <div key={goal}>
                            <input type="checkbox" checked={postReg.goals.includes(goal)} onChange={() => toggleCheckbox(postReg.goals, goal, 'goals')} />
                            <label style={{ marginLeft: '6px' }}>{goal}</label>
                            {goal === 'Other' && postReg.goals.includes('Other') && (
                                <TextField style={textFieldStyle} label="Other Goal" value={postReg.otherGoal} onChange={e => setPostReg({ ...postReg, otherGoal: e.target.value })} />
                            )}
                        </div>
                    ))}

                    <div style={buttonContainer}>
                        <Button size="small" sx={{ fontWeight: 'bold', color: 'white', backgroundColor: '#723E49' }} onClick={() => setOpenPostReg(false)}>Exit</Button>
                        <Button size="small" disabled={submitting} sx={{ fontWeight: 'bold', color: 'white', backgroundColor: '#00B3B5' }} onClick={handleSavePostReg}>Save</Button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default EditAccount;
